import { DevPost } from '../types';

export const devPosts: DevPost[] = [
  {
    id: 'vibe-coding-paradigm',
    title: 'The Art of Vibe Coding: Architecture in the Age of Generative AI',
    summary: 'How flow-state engineering, AI co-pilots, and prompt-driven system architecture are redefining how developers write games, tools, and platforms.',
    date: '2026-05-12',
    tags: ['Vibe Coding', 'AI Architecture', 'Productivity'],
    url: 'https://atomixnmc.github.io/mydevblog/',
    category: 'Vibe Coding'
  },
  {
    id: 'fractals-gpu-shaders',
    title: 'Exploring Mathematical Fractals & Real-Time Raymarched Shaders',
    summary: 'Deep dive into Mandelbrot sets, 3D Mandelbulb rendering, and optimizing compute shaders for real-time interactive visual art.',
    date: '2025-10-18',
    tags: ['Fractals', 'GLSL', 'Compute Shaders', 'Math'],
    url: 'https://atomixnmc.github.io/mydevblog/',
    category: 'Fractals & AI'
  },
  {
    id: 'game-engine-ecs-design',
    title: 'Building High-Performance ECS for Modern 3D/2D Game Engines',
    summary: 'Architecting cache-friendly memory layouts, multi-threaded entity updates, and deterministic state synchronization in Atom3D & AtomixGameEngine.',
    date: '2025-04-05',
    tags: ['Game Engine', 'ECS', 'C++', 'Vulkan'],
    url: 'https://atomixnmc.github.io/mydevblog/',
    category: 'Game Engine'
  },
  {
    id: 'ai-audio-pipeline-design',
    title: 'Designing Latent Audio Synthesis & Suno-Inspired Music Pipelines',
    summary: 'Structuring end-to-end generative music workflows, stem separation, spectrogram reconstruction, and real-time audio FX mastering.',
    date: '2024-11-22',
    tags: ['AI Audio', 'Pipeline', 'Suno Inspiration', 'DSP'],
    url: 'https://atomixnmc.github.io/mydevblog/',
    category: 'Architecture'
  }
];
